import { keyBy } from "lodash";

import addressApi from "@/api/address";

export default {
  actions: {
    async get({ commit }, addressId) {
      const record = await addressApi.get(addressId);
      return commit("setRecord", record);
    },
    async create({ commit, state }) {
      const record = await addressApi.create(state.record);
      commit("setRecord", record);
    },
    async list({ commit }) {
      const list = await addressApi.list();
      return commit("setList", list);
    },
    async remove({ dispatch }, id) {
      await addressApi.remove(id);
      await dispatch("list");
      return true;
    },
    async update({ commit }, [addressId, data]) {
      const record = await addressApi.update(addressId, data);
      return commit("setRecord", record);
    },
  },
  getters: {
    get: state => id => {
      return state.hash[id];
    },
    getById: state => id => {
      return state.list.find(address => address.addressId === id);
    },
  },
  mutations: {
    setList(state, list) {
      state.list = list;
      state.hash = keyBy(list, "addressId");
    },
    setRecord(state, record) {
      state.record = record;
    },
  },
  namespaced: true,
  state: {
    hash: null,
    list: [],
    record: {},
  },
};
